import React from 'react';

export interface IconProps {
  size?: number;
  className?: string;
  color?: string;
}

export const IconUsers: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M14 17V15C14 13.8954 13.1046 13 12 13H8C6.89543 13 6 13.8954 6 15V17M16 11C17.1046 11 18 10.1046 18 9C18 7.89543 17.1046 7 16 7M4 11C2.89543 11 2 10.1046 2 9C2 7.89543 2.89543 7 4 7M13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
